import { action, createRequestTypes } from '../base';

export const einvoiceEwaybillActionTypes = {
  ENABLE_EWAY_BILL: createRequestTypes('ENABLE_EWAY_BILL'),
  AUTH_GST_SUVIDHA: createRequestTypes('AUTH_GST_SUVIDHA'),
  PUSH_IRP: createRequestTypes('PUSH_IRP'),
  PUSH_CN_TO_IRP: createRequestTypes('PUSH_CN_TO_IRP'),
  GEN_EWAY_BILL: createRequestTypes('GEN_EWAY_BILL'),
  GET_EWAY_BILLS: createRequestTypes('GET_EWAY_BILLS'),
  CANCEL_IRP: createRequestTypes('CANCEL_IRP'),
  DEACTIVATE_GST_SUVIDHA: createRequestTypes('DEACTIVATE_GST_SUVIDHA'),
  CANCEL_EWAY_BILL: createRequestTypes('CANCEL_EWAY_BILL'),
  ADD_TRANSPORTATION: createRequestTypes('ADD_TRANSPORTATION'),
  EXCLUDE_EWAY_BILLS: createRequestTypes('EXCLUDE_EWAYBILLS'),
  FETCH_EWAY_BILL: createRequestTypes('FETCH_EWAY_BILL'),
};

class EinvoiceEwaybillIntegrationActions {
    /**
     *
     * @param payload
     * @param callback
     * @returns {{type: *}}
     */
    enableEinvoiceEwaybill = (payload, callback) => action(einvoiceEwaybillActionTypes.ENABLE_EWAY_BILL.REQUEST, { payload, callback });

    /**
     *
     * @param enableEinvoiceEwaybillLoading
     * @returns {{type: *}}
     */
    enableEinvoiceEwaybillLoading = (enableEinvoiceEwaybillLoading) => action(einvoiceEwaybillActionTypes.ENABLE_EWAY_BILL.LOADING, {
      enableEinvoiceEwaybillLoading,
    })

    /**
     *
     * @param enableEinvoiceEwaybillSuccess
     * @returns {{type: *}}
     */
    enableEinvoiceEwaybillSuccess = (enableEinvoiceEwaybillSuccess) => action(einvoiceEwaybillActionTypes.ENABLE_EWAY_BILL.SUCCESS, {
      enableEinvoiceEwaybillSuccess,
    })

    /**
     *
     * @param payload
     * @param callback
     * @returns {{type: *}}
     */
    genEwaybill = (payload, callback) => action(einvoiceEwaybillActionTypes.GEN_EWAY_BILL.REQUEST, { payload, callback });

    /**
     *
     * @param genEwaybillLoading
     * @returns {{type: *}}
     */
    genEwaybillLoading = (genEwaybillLoading) => action(einvoiceEwaybillActionTypes.GEN_EWAY_BILL.LOADING, {
      genEwaybillLoading,
    })

    /**
     *
     * @param genEwaybillSuccess
     * @returns {{type: *}}
     */
    genEwaybillSuccess = (genEwaybillSuccess) => action(einvoiceEwaybillActionTypes.GEN_EWAY_BILL.SUCCESS, {
      genEwaybillSuccess,
    })

    /**
     *
     * @param page
     * @param limit
     * @param keyword
     * @param tenantId
     * @param doctype
     * @param status
     * @param fromDate
     * @param toDate
     * @returns {{type: *}}
     */
    getEwaybills = (page, limit, keyword, tenantId, doctype, status, fromDate, toDate) => action(einvoiceEwaybillActionTypes.GET_EWAY_BILLS.REQUEST, {
      page, limit, keyword, tenantId, doctype, status, fromDate, toDate,
    });

    /**
     *
     * @param getEwaybillsLoading
     * @returns {{type: *}}
     */
    getEwaybillsLoading = (getEwaybillsLoading) => action(einvoiceEwaybillActionTypes.GET_EWAY_BILLS.LOADING, {
      getEwaybillsLoading,
    })

    /**
     *
     * @param eWaybills
     * @returns {{type: *}}
     */
    getEwaybillsSuccess = (eWaybills) => action(einvoiceEwaybillActionTypes.GET_EWAY_BILLS.SUCCESS, {
      eWaybills,
    })

    /**
     *
     * @param payload
     * @param callback
     * @returns {{type: *}}
     * @constructor
     */
    GSTAuthentication = (payload, callback) => action(einvoiceEwaybillActionTypes.AUTH_GST_SUVIDHA.REQUEST, { payload, callback });

    /**
     *
     * @param GSTAuthenticationLoading
     * @returns {{type: *}}
     * @constructor
     */
    GSTAuthenticationLoading = (GSTAuthenticationLoading) => action(einvoiceEwaybillActionTypes.AUTH_GST_SUVIDHA.LOADING, {
      GSTAuthenticationLoading,
    })

    /**
     *
     * @param GSTAuthenticationSuccess
     * @returns {{type: *}}
     * @constructor
     */
    GSTAuthenticationSuccess = (GSTAuthenticationSuccess) => action(einvoiceEwaybillActionTypes.AUTH_GST_SUVIDHA.SUCCESS, {
      GSTAuthenticationSuccess,
    })

    /**
     *
     * @param payload
     * @param callback
     * @returns {{type: *}}
     * @constructor
     */
    GSTDeauthentication = (payload, callback) => action(einvoiceEwaybillActionTypes.DEACTIVATE_GST_SUVIDHA.REQUEST, { payload, callback });

    /**
     *
     * @param GSTDeauthenticationLoading
     * @returns {{type: *}}
     * @constructor
     */
    GSTDeauthenticationLoading = (GSTDeauthenticationLoading) => action(einvoiceEwaybillActionTypes.DEACTIVATE_GST_SUVIDHA.LOADING, {
      GSTDeauthenticationLoading,
    })

    /**
     *
     * @param GSTDeauthenticationSuccess
     * @returns {{type: *}}
     * @constructor
     */
    GSTDeauthenticationSuccess = (GSTDeauthenticationSuccess) => action(einvoiceEwaybillActionTypes.DEACTIVATE_GST_SUVIDHA.SUCCESS, {
      GSTDeauthenticationSuccess,
    })

    /**
     *
     * @param payload
     * @param callback
     * @returns {{type: *}}
     */
    pushIRP= (payload, callback) => action(einvoiceEwaybillActionTypes.PUSH_IRP.REQUEST, { payload, callback });

    /**
     *
     * @param pushIRPLoading
     * @returns {{type: *}}
     */
    pushIRPLoading = (pushIRPLoading) => action(einvoiceEwaybillActionTypes.PUSH_IRP.LOADING, {
      pushIRPLoading,
    })

    /**
     *
     * @param payload
     * @param callback
     * @returns {{type: *}}
     */
    pushCnToIRP= (payload, callback) => action(einvoiceEwaybillActionTypes.PUSH_CN_TO_IRP.REQUEST, { payload, callback });

    /**
     *
     * @param pushIRPLoading
     * @returns {{type: *}}
     */
    pushCnToIRPLoading = (pushCnToIRPLoading) => action(einvoiceEwaybillActionTypes.PUSH_CN_TO_IRP.LOADING, {
      pushCnToIRPLoading,
    })

    /**
     *
     * @param payload
     * @param callback
     * @returns {{type: *}}
     */
    cancelIRP = (payload, callback) => action(einvoiceEwaybillActionTypes.CANCEL_IRP.REQUEST, { payload, callback });

    /**
     *
     * @param cancelIRPLoading
     * @returns {{type: *}}
     */
    cancelIRPLoading = (cancelIRPLoading) => action(einvoiceEwaybillActionTypes.CANCEL_IRP.LOADING, {
      cancelIRPLoading,
    })

    /**
     *
     * @param payload
     * @param callback
     * @returns {{type: *}}
     */
    cancelEwaybill= (payload, callback) => action(einvoiceEwaybillActionTypes.CANCEL_EWAY_BILL.REQUEST, { payload, callback });

    /**
     *
     * @param cancelEwaybillLoading
     * @returns {{type: *}}
     */
    cancelEwaybillLoading = (cancelEwaybillLoading) => action(einvoiceEwaybillActionTypes.CANCEL_EWAY_BILL.LOADING, {
      cancelEwaybillLoading,
    })

    /**
     *
     * @param payload
     * @param callback
     * @returns {{type: *}}
     */
    addTransporter= (payload, callback) => action(einvoiceEwaybillActionTypes.ADD_TRANSPORTATION.REQUEST, { payload, callback });

    /**
     *
     * @param addTransporterLoading
     * @returns {{type: *}}
     */
    addTransporterLoading = (addTransporterLoading) => action(einvoiceEwaybillActionTypes.ADD_TRANSPORTATION.LOADING, {
      addTransporterLoading,
    })

    /**
     *
     * @param payload
     * @param callback
     * @returns {{type: *}}
     */
    excludeEwayBills = (payload, callback) => action(einvoiceEwaybillActionTypes.EXCLUDE_EWAY_BILLS.REQUEST, {
      payload, callback,
    })

    /**
     *
     * @param excludeEwayBillsLoading
     * @returns {{type: *}}
     */
    excludeEwayBillsLoading = (excludeEwayBillsLoading) => action(einvoiceEwaybillActionTypes.EXCLUDE_EWAY_BILLS.LOADING, {
      excludeEwayBillsLoading,
    })

    /**
     *
     * @param payload
     * @param callback
     * @returns {{type: *}}
     */
    fetchEwayBill = (payload, callback) => action(einvoiceEwaybillActionTypes.FETCH_EWAY_BILL.REQUEST, {
      payload, callback,
    })

    /**
     *
     * @param fetchEwayBillLoading
     * @returns {{type: *}}
     */
    fetchEwayBillLoading = (fetchEwayBillLoading) => action(einvoiceEwaybillActionTypes.FETCH_EWAY_BILL.LOADING, {
      fetchEwayBillLoading,
    })
}
export default new EinvoiceEwaybillIntegrationActions();
